import { render } from "./OfficeDetailView.vue?vue&type=template&id=336dde04"
import script from "./OfficeDetailView.vue?vue&type=script&lang=js"
export * from "./OfficeDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__